import { axiosInstance as axios } from 'Api';
import { handlingResponse } from 'Utility/globalMethods';
import { Config } from 'Constants/config_env';
/* eslint-disable global-require */
if (ISMOCK) {
	require('Mocks/merchant/merchant');
}

export async function merchantList(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `merchant/list`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function merchantFind(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `merchant/find`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function merchantDetail(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `merchant/detail`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function deleteMerchant(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `merchant/delete`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function createMerchant(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `merchant/create`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function updateMerchant(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `merchant/update`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
export async function generateMerchantReportStatus(params) {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `merchant/report/generateStatus`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
// @generator api:method
